module.exports = __webpack_public_path__ + "static/media/logo.deedc405.png";